// The first-visit A/B (uiux/10.19 Nati Rework/plan.md, Phase 3): the Q1 → Q2
// question tree, or one screen of four tiles. A visitor's arm is a pure
// function of their anonymous id, so it holds across visits and nothing has
// to be stored. Which arm someone saw is in the data already: the tiles arm
// is the only one that ever sends `onboarding_shown` with detail "four".
//
// FOUR_TILES_SHARE starts at 0: the tree needs a baseline before anything is
// judged against it. Raise it to 0.5 to run the test. `?ob=tiles|tree` forces
// an arm (QA, snapshots).

export type OnboardingArm = "tree" | "tiles";

export const FOUR_TILES_SHARE = 0;

/** FNV-1a into [0, 1). */
function unit(id: string): number {
  let h = 2166136261;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) / 2 ** 32;
}

export function onboardingArm(anonId: string, override: string | null, share: number = FOUR_TILES_SHARE): OnboardingArm {
  if (override === "tiles" || override === "tree") return override;
  return unit(anonId) < share ? "tiles" : "tree";
}
